import React, { Component } from 'react'

export default class QA extends Component {
    render() {
        return (
        <div className="start">
            <h1>Tests</h1>
            <p>
              <a href="/labs/placement/tvsa?apiKey=b7220655bd54399edac9d9c6962f521d7c1cfed0f168e908a37ce4b2b6c7bcd2">backend: labs, placement : tvsa</a>
            </p>
            <p>
              <a href="/labs/placement/spotx?apiKey=b7220655bd54399edac9d9c6962f521d7c1cfed0f168e908a37ce4b2b6c7bcd2">backend: labs, placement : spotx</a>
            </p>
            <p>
              <a href="/labs/placement/spotx2?apiKey=b7220655bd54399edac9d9c6962f521d7c1cfed0f168e908a37ce4b2b6c7bcd2">backend: labs, placement : spotx2</a>
            </p>
            <p>
              <a href="/labs/placement/tvsb?apiKey=b7220655bd54399edac9d9c6962f521d7c1cfed0f168e908a37ce4b2b6c7bcd2">backend: labs, placement : tvsb</a>
            </p>
            <p>
              <a href="/labs/placement/tvsc?apiKey=b7220655bd54399edac9d9c6962f521d7c1cfed0f168e908a37ce4b2b6c7bcd2">backend: labs, placement : tvsc</a>
            </p>
            <p>
              <a href="/ci/placement/SevenPassLoginTest?apiKey=b7220655bd54399edac9d9c6962f521d7c1cfed0f168e908a37ce4b2b6c7bcd2"> backend: ci, placement: SevenPassLoginTest</a>
            </p>
            <p>
                <a href="/ci/placement/KWIZZAD_7PASS?apiKey=b7220655bd54399edac9d9c6962f521d7c1cfed0f168e908a37ce4b2b6c7bcd2">KWIZZAD_7PASS</a>
            </p>
            <p>
                <a href="/kwizzad/placement/KWIZZAD_7PASS?apiKey=b81e71a86cf1314d249791138d642e6c4bd08240f21dd31811dc873df5d7469d">KWIZZAD_7PASS LIVE</a>
            </p>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/pages/qa.jsx